import { Box, Card, CardBody, Stack, Text } from '@chakra-ui/react'
import type { TeamMember } from '@twlvxtwlv/types'
import { useState } from 'react'
import Image from 'next/image'
import { AnimatePresence, LayoutGroup, motion } from 'framer-motion'

export interface TeamGalleryCardProps {
  teamMember: TeamMember
}

export const TeamGalleryCard = ({ teamMember }: TeamGalleryCardProps) => {
  const { jobTitle, name, avatarImage, description, hoverImage } = teamMember

  const [isHovering, setIsHovering] = useState(false)

  const showHoverImage = isHovering && !!hoverImage

  return (
    <Card
      border="1px solid"
      borderColor="txtWhite"
      borderRadius="0"
      height="full"
      width="full"
      color="txtWhite"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={() => setIsHovering(!isHovering)}
    >
      <CardBody backgroundColor="txtBlack" p="0">
        <Stack h="full">
          <Box w="full" h="55%">
            <AnimatePresence>
              <LayoutGroup>
                <motion.div
                  layout
                  initial={false}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    opacity: showHoverImage ? 1 : 0,
                    transition: 'all 0.3s ease',
                    height: '100%',
                    width: '100%',
                  }}
                >
                  <Image
                    src={hoverImage ?? ''}
                    alt={`${name} image`}
                    fill
                    style={{
                      objectFit: 'cover',
                    }}
                    priority
                  />
                </motion.div>

                <motion.div
                  layout
                  initial={false}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    opacity: showHoverImage ? 0 : 1,
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Image
                    src={avatarImage}
                    alt={`${name} avatar image`}
                    width="500"
                    height="500"
                    style={{
                      objectFit: 'cover',
                    }}
                  />
                </motion.div>
              </LayoutGroup>
            </AnimatePresence>
          </Box>
          <Stack flex="1" justifyContent="end" zIndex="100" p="1rem" overflowWrap="break-word">
            <AnimatePresence>
              <LayoutGroup>
                <motion.div layout>
                  <Text fontWeight="600">{jobTitle}</Text>
                  <Text fontSize="3xl" fontWeight="900">
                    {name.toUpperCase()}
                  </Text>
                </motion.div>
                <motion.div layout>
                  {isHovering ? (
                    <Box>
                      <Text fontSize="md" fontWeight="900">
                        {description}
                      </Text>
                    </Box>
                  ) : null}
                </motion.div>
              </LayoutGroup>
            </AnimatePresence>
          </Stack>
        </Stack>
      </CardBody>
    </Card>
  )
}
